import { render, staticRenderFns } from "./RequisitionTableActions.vue?vue&type=template&id=4fa83d72&"
import script from "./RequisitionTableActions.vue?vue&type=script&lang=js&"
export * from "./RequisitionTableActions.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionTableActions.vue?vue&type=style&index=0&id=4fa83d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports